import React from 'react';

const NoRoute = () => (
  <div>
    <h1>404</h1>
    <h4>Not found</h4>
  </div>
);

export default NoRoute;



// WEBPACK FOOTER //
// ./src/containers/NoRoute.js